// @ts-nocheck - it is just easier to remove checking since it is just the pasted Glady script.
"use client"
import { type CentraMarketCode } from "@/data/supported-markets"
import {
    type GladlyConfiguredApps,
    type GladlyEnvironments
} from "@/lib/scripts/Gladly/index"
import Script from "next/script"
import React from "react"

export type GladlyScriptProps<Environment extends GladlyEnvironments> = {
    appId: GladlyConfiguredApps[Environment][CentraMarketCode | "default"]
    environment?: Environment
    variableName?: string
    readyCallback?: () => void
    errorCallback?: (error: string) => void
}
export const GladlyScript: React.FC<GladlyScriptProps> = ({
    appId,
    variableName = "Gladly",
    environment,
    readyCallback,
    errorCallback
}) => {
    return (
        <Script
            strategy="lazyOnload"
            id={`gladly-script-${appId}`}
            onReady={readyCallback ?? (() => {})}
            onError={errorCallback ?? (() => {})}
        >
            {
                !(function (c, n, r, t) {
                    if (!c[r]) {
                        let i, d
                        const p = []
                        ;((d =
                            "PROD" !== t && t
                                ? "STAGING" === t
                                    ? "https://cdn.gladly.qa/gladly/chat-sdk/widget.js"
                                    : t
                                : "https://cdn.gladly.com/chat-sdk/widget.js"),
                            (c[r] = {
                                init: function () {
                                    i = arguments
                                    const e = {
                                        then: function (t) {
                                            return (p.push({ type: "t", next: t }), e)
                                        },
                                        catch: function (t) {
                                            return (p.push({ type: "c", next: t }), e)
                                        }
                                    }
                                    return e
                                }
                            }),
                            (c.__onHelpAppHostReady__ = function (t) {
                                if (
                                    (delete c.__onHelpAppHostReady__,
                                    ((c[r] = t).loaderCdn = d),
                                    i)
                                )
                                    for (
                                        let e = t.init.apply(t, i), n = 0;
                                        n < p.length;
                                        n++
                                    ) {
                                        const a = p[n]
                                        e =
                                            "t" === a.type
                                                ? e.then(a.next)
                                                : e.catch(a.next)
                                    }
                            }),
                            (function () {
                                try {
                                    const t = n.getElementsByTagName("script")[0],
                                        e = n.createElement("script")
                                    ;((e.async = !0),
                                        (e.src = d + "?q=" + new Date().getTime()),
                                        t.parentNode.insertBefore(e, t))
                                } catch (t) {}
                            })())
                    }
                })(window, document, variableName, environment)
            }
        </Script>
    )
}
